// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"15d6f114","453":"a6a97343","732":"c1254fbd","977":"86520f60"}[chunkId] + ".chunk.js";
};